import { useCallback, useState } from 'react'

import { SkeletonShapeProps } from './types'
import { Skeleton } from '../../Skeleton'
import { BaseView } from '../../base'

export const SkeletonShape = ({
  style,
  circle = false,
  circleSize = 24,
  w,
  h,
  rounded = 0,
  ...rest
}: SkeletonShapeProps) => {
  const [parentLayout, setParentLayout] = useState({
    width: 0,
    height: 0,
  })

  const width = typeof w === 'number' ? w : parentLayout.width
  const height = typeof h === 'number' ? h : parentLayout.height

  const rx = circle ? circleSize / 2 : rounded

  const onParentLayout = useCallback((event: React.SyntheticEvent) => {
    const target = event.target as HTMLElement
    const rect = target.getBoundingClientRect()
    setParentLayout({
      height: rect.height,
      width: rect.width,
    })
  }, [])

  return (
    <BaseView
      style={{
        position: 'relative',
        width: circle ? circleSize : w,
        height: circle ? circleSize : h,
        borderRadius: circle ? circleSize / 2 : rounded,
        ...style,
      }}
      onLayout={onParentLayout}
      {...rest}
    >
      {parentLayout.width > 0 && parentLayout.height > 0 && (
        <Skeleton
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
          }}
          viewBox={`0 0 ${width} ${height}`}
        >
          <rect rx={rx} ry={rx} width="100%" height="100%" />
        </Skeleton>
      )}
    </BaseView>
  )
}
